module.exports = __webpack_public_path__ + "static/media/scientist.2b125117.svg";